import ReactGA from 'react-ga4'; // https://github.com/codler/react-ga4
import * as Sentry from '@sentry/react';

const options = {
  transport: 'xhr',
  testMode: process.env.NODE_ENV === 'development',
  nonInteraction: true
};

const track = {
  initialize: () => {
    if (!process.env.REACT_APP_GA_ID) {
      return;
    }

    ReactGA.initialize(process.env.REACT_APP_GA_ID);
  },

  vitals: ({ id, name, value }) => {
    ReactGA.event({
      category: 'Vitals',
      action: name,
      label: id,
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      ...options
    });
  },

  // https://developers.google.com/tag-platform/gtagjs/reference/events
  event: (name, params = {}) => {
    if (!ReactGA.isInitialized) {
      return;
    }

    ReactGA.event(name, params);
  },

  exception: (err, fatal = false) => {
    try {
      console.error(err);

      let description = `Version ${process.env.REACT_APP_VERSION}\n`;
      description += `・${process.env.REACT_APP_BUILD_DATE}\n`;
      description += `・Plateforme ${window.env.platform}\n`;
      description += window.env.deviceModel ? `・Appareil ${window.env.deviceModel}\n\n` : '';

      if (err instanceof Error) {
        description += err.stack;
      } else if (typeof err === 'object') {
        description += JSON.stringify(err, null, 2);
      } else if (typeof err === 'string') {
        description += err;
      }

      // Création d'un ticket Jira
      Sentry.captureException(err, { extra: { description, fatal } });

      // Création d'un évènement analytics
      if (ReactGA.isInitialized) {
        ReactGA.event('exception', { description, fatal });
      }
    } catch (err) {
      console.error(err);
    }
  },

  setUser: (params) => {
    if (!ReactGA.isInitialized) {
      return;
    }

    ReactGA.set({ user_properties: params });
  },

  action: (action, params = {}) => {
    if (!ReactGA.isInitialized) {
      return;
    }

    ReactGA.event({
      category: 'User actions',
      action,
      label: params.label || undefined,
      value: params.value || undefined,
      ...options
    });
  }
};

export default track;
